<template>
    <div class="aboutcon">
        <div class="abcont1"><img src="../../img/jiejuefangan.jpg"></div>
    </div>
</template>
<script>
import h2Title from '../../components/h2Title'
import foot from '../../components/foot'
import { WOW } from 'wowjs'
export default {
    data: function () {
        return {
            list: '',
            description: '',
            logoimg: ''
        }
    },
    components: {
        h2Title,
        foot
    },
    mounted() {
        new WOW().init()
        this.companyload()
    },
    methods: {
        companyload: function () {
            this.$axios.get('/api/about/list')
                .then((res) => {
                    var i = 4
                    this.description = res.data.list[i].description
                    this.logoimg = res.data.list[i].logo_url
                })
        },
    }
}
</script>
<style lang="less">
.mb5 {
    margin-bottom: 5px;
}

.abcont1 {
    width: 1200px;
    // border: solid 1px #cccccc;
    margin: 15px auto 5px;
    font-size: 24px;
    overflow: hidden;

    img {
        width: 102%;
        height: auto;
        // border: 5px solid #fff;
    }

    .abcont1-con {
        border: solid 1px #cccccc;
        background-color: #fff;
        padding-top: 35px;

        .abcont1-2 {
            margin-top: 40px;
            padding-bottom: 35px;

            .abcont1-2img {
                width: 407px;
                float: left;
                height: 318px;
                margin-left: 37px;
                margin-right: 42px;
                border-radius: 50px;
                background-color: #2172ca;
                border: 3px solid #dccd14;

            }

            img {
                width: 200px;
                height: 200px;
                margin-top: 30px;
                margin-top: 60px;
                margin-left: -5px;
            }
        }
    }
}

.abcont2l,
.abcont2c,
.abcont2r {
    text-align: center;
}

.abcont2 {
    padding-top: 30px !important;
}

.ab-tit1 {
    color: #666666;
    text-transform: uppercase;
    padding-bottom: 5px;
    font-size: 24px;
}

.ab-tit2 {
    font-weight: bold;
    font-size: 24px;
    position: relative;

    &::before,
    &::after {
        position: absolute;
        height: 1px;
        background-color: currentColor;
        content: '';
    }

}
</style>






// WEBPACK FOOTER //
// src/views/solution/index.vue